// extracted by mini-css-extract-plugin
export default {"textButton":"Button_textButton__0U64i","script_button":"Button_script_button__vQQtu","busy":"Button_busy__yGn1U"};